import { FC } from 'react'

const SwitchVatIcon: FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_39540_130675)">
      <path
        d="M9.21094 0.546875L11.3776 2.71354L9.21094 4.88021"
        stroke="#78C406"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.625 5.95313V4.86979C1.625 4.29516 1.85327 3.74406 2.2596 3.33773C2.66593 2.9314 3.21703 2.70313 3.79167 2.70312H11.375"
        stroke="#78C406"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79167 12.4583L1.625 10.2917L3.79167 8.125"
        stroke="#78C406"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 7.04688V8.13021C11.375 8.70484 11.1467 9.25594 10.7404 9.66227C10.3341 10.0686 9.78297 10.2969 9.20833 10.2969H1.625"
        stroke="#78C406"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_39540_130675">
        <rect
          width="13"
          height="13"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>

)

export default SwitchVatIcon
